import { Navigate, Route, Routes } from "react-router-dom";
import PageShell from "@/components/PageShell";
import { useMe } from "@/lib/auth";
import McpServers from "@/components/McpServers";
import EmbeddingsAdmin from "./EmbeddingsAdmin";
import Endpoints from "./Endpoints";
import Groups from "./Groups";
import VoiceAdmin from "./VoiceAdmin";
import Users from "./Users";

const tabs = [
  { to: "/admin", label: "Users" },
  { to: "/admin/groups", label: "Groups" },
  { to: "/admin/endpoints", label: "Endpoints & models" },
  { to: "/admin/mcp", label: "MCP servers" },
  { to: "/admin/voice", label: "Voice" },
  { to: "/admin/search", label: "Search" },
];

export default function Admin() {
  const me = useMe().data;
  if (me?.role !== "admin") return <Navigate to="/" replace />;
  return (
    <PageShell title="Administration" tabs={tabs}>
      <Routes>
        <Route index element={<Users />} />
        <Route path="groups" element={<Groups />} />
        <Route path="endpoints" element={<Endpoints />} />
        <Route path="mcp" element={<McpServers admin />} />
        <Route path="voice" element={<VoiceAdmin />} />
        <Route path="search" element={<EmbeddingsAdmin />} />
      </Routes>
    </PageShell>
  );
}
